
import { supabase } from "@/integrations/supabase/client";
import { PlaceDetailsResponse, PlaceResult } from "@/types/place";

export const placeDetails = async (placeId: string): Promise<PlaceDetailsResponse> => {
  try {
    const response = await supabase.functions.invoke('place-details', {
      body: { placeId }
    });

    return response.data;
  } catch (error) {
    console.error("Error getting place details:", error);
    return { result: {} as PlaceResult, status: 'ERROR' };
  }
};
